// Copyright 2024-present BAIKAL AI Inc.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none"
// @generated from file bareun/lang_common.proto (package bareun, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bareun/lang_common.proto.
 */
export const file_bareun_lang_common: GenFile = /*@__PURE__*/
  fileDesc("ChhiYXJldW4vbGFuZ19jb21tb24ucHJvdG8SBmJhcmV1biJBCghUZXh0U3BhbhIPCgdjb250ZW50GAEgASgJEhQKDGJlZ2luX29mZnNldBgCIAEoBRIOCgZsZW5ndGgYAyABKAUiLQoIRG9jdW1lbnQSDwoHY29udGVudBgCIAEoCRIQCghsYW5ndWFnZRgEIAEoCSo4CgxFbmNvZGluZ1R5cGUSCAoETk9ORRAAEggKBFVURjgQARIJCgVVVEYxNhACEgkKBVVURjMyEANCgAEKCmNvbS5iYXJldW5CD0xhbmdDb21tb25Qcm90b1ABWiliYXJldW4uYWkvbGFuZy9iYXJldW4vZ2VucHJvdG8vYmFyZXVuO3N2Y6ICA0JYWKoCBkJhcmV1bsoCBkJhcmV1buICEkJhcmV1blxHUEJNZXRhZGF0YeoCBkJhcmV1bmIGcHJvdG8z");

/**
 * 텍스트 조각
 *
 * @generated from message bareun.TextSpan
 */
export type TextSpan = Message<"bareun.TextSpan"> & {
  /**
   * 텍스트 조각의 내용
   *
   * @generated from field: string content = 1;
   */
  content: string;

  /**
   * 텍스트 조각의 위치
   * EncodingType에 따라서 위치의 값이 달라진다.
   *
   * @generated from field: int32 begin_offset = 2;
   */
  beginOffset: number;

  /**
   * 길이
   *
   * @generated from field: int32 length = 3;
   */
  length: number;
};

/**
 * Describes the message bareun.TextSpan.
 * Use `create(TextSpanSchema)` to create a new message.
 */
export const TextSpanSchema: GenMessage<TextSpan> = /*@__PURE__*/
  messageDesc(file_bareun_lang_common, 0);

/**
 *
 * Represents the input to API methods.
 *
 * @generated from message bareun.Document
 */
export type Document = Message<"bareun.Document"> & {
  /**
   * 입력 전체의 내용
   * 여러 문장이 입력되면 "\n"을 넣어준다.
   *
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * 문서의 언어. 현재는 ko_KR 만 지원한다.
   *
   * @generated from field: string language = 4;
   */
  language: string;
};

/**
 * Describes the message bareun.Document.
 * Use `create(DocumentSchema)` to create a new message.
 */
export const DocumentSchema: GenMessage<Document> = /*@__PURE__*/
  messageDesc(file_bareun_lang_common, 1);

/**
 * Represents the text encoding that the caller uses to process the output.
 * Providing an `EncodingType` is recommended because the API provides the
 * beginning offsets for various outputs, such as tokens and mentions, and
 * languages that natively use different text encodings may access offsets
 * differently.
 *
 * @generated from enum bareun.EncodingType
 */
export enum EncodingType {
  /**
   * If `EncodingType` is not specified, encoding-dependent information (such as
   * `begin_offset`) will be set at `-1`.
   *
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * Encoding-dependent information (such as `begin_offset`) is calculated based
   * on the UTF-8 encoding of the input. C++ and Go are examples of languages
   * that use this encoding natively.
   *
   * @generated from enum value: UTF8 = 1;
   */
  UTF8 = 1,

  /**
   * Encoding-dependent information (such as `begin_offset`) is calculated based
   * on the UTF-16 encoding of the input. Java and JavaScript are examples of
   * languages that use this encoding natively.
   *
   * @generated from enum value: UTF16 = 2;
   */
  UTF16 = 2,

  /**
   * Encoding-dependent information (such as `begin_offset`) is calculated based
   * on the UTF-32 encoding of the input. Python is an example of a language
   * that uses this encoding natively.
   *
   * @generated from enum value: UTF32 = 3;
   */
  UTF32 = 3,
}

/**
 * Describes the enum bareun.EncodingType.
 */
export const EncodingTypeSchema: GenEnum<EncodingType> = /*@__PURE__*/
  enumDesc(file_bareun_lang_common, 0);

